import * as React from "react";
function SvgGroupBubblesEmpty(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M2.4 31H0v-4.8h2.4V31zM9.7 2.4V0H4.9l-.1 2.4h4.9zM2.4 4.1H0v4.8h2.4V4.1zm0 33.1H0v2.4c.1 1 .4 2 .8 2.9L3 41.4c-.4-.6-.5-1.2-.6-1.8v-2.4zm0-22.1H0v4.8h2.4v-4.8zM42.8 0h-4.9v2.4h4.9V0zm-11 0h-4.9v2.4h4.9V0zm-11 0h-4.9v2.4h4.9V0zm18 45.6V48H44l-.2-2.4h-5zm6.8-15.1H48v-4.8h-2.4v4.8zm-5.3-4.2h-2.2v6l-5.8-5V31c.1 1.1-.7 2.2-1.8 2.3h-2.4v6l-6.8-6H9c-1.2 0-2.2-1.1-2.2-2.3V18.4c0-1.2.8-2.2 2-2.2h7.9v-4.8c0-1.2.8-2.2 2-2.2h21.6c1.1 0 1.9.8 1.9 1.9V24c.1 1.1-.7 2.2-1.8 2.3h-.1zm-9.7-7.9c0-.1 0-.2-.1-.4H9c-.1 0-.4.1-.4.4v12.7c0 .2.1.5.4.5h13.1l4.3 3.8v-3.8h4.1c.1-.1.2-.4.1-.5V18.4zm9.7 6.1c.1-.1.2-.4.1-.5V11.4c0-.1 0-.2-.1-.4H18.7c-.1 0-.4.1-.4.4v4.9h12.1c1.1 0 1.9.8 1.9 1.9V25l4 3.5v-3.8h4v-.2zm5.3-5.1H48v-4.8h-2.4v4.8zM5.3 47.8c.3.1.7.2 1.1.2h4.2v-2.5H6.2l-.9 2.3zm40.3-8.2c0 .6-.1 1.2-.2 1.8l2.4.5c.1-.7.2-1.4.2-2.2v-2.9h-2.4v2.8zM16.8 48h4.9v-2.4h-4.9V48zm10.9 0h4.9v-2.4h-4.9V48zM45.6 3.6v4.8H48V3.6h-2.4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGroupBubblesEmpty);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
